<template>
  <Button class="BackButton">
    <span class="icon" v-html="arrowLeftSvg"></span>
    <slot></slot>
  </Button>
</template>

<script setup>
import arrowLeftSvg from '~/assets/ui/arrow-left.svg?raw'
import Button from './Button.vue'
</script>

<style scoped>
.BackButton {
  background-color: transparent;
  border-color: var(--text-color-black);
  color: var(--text-color-black);
}
.BackButton:hover {
  background-color: #08192E;
  color: var(--text-color-white);
}
.BackButton:focus {
  background-color: #1E4B7E;
  border-color: #08192E;
  color: var(--text-color-white);
}
.icon:deep(svg) {
  display: inline-block;
  margin-right: 0.5rem;
}
</style>
